module.exports = __webpack_public_path__ + "static/media/menu_black.eb12d30a.svg";